import { memo } from 'react';
import Grid from '../Grid';
import { AB1, B1, S4 } from '../../theme';
import ChipsGroup from '../ChipsGroup';
import Typography from '../Typography';

export interface ILinkedServicesProps {
  domainRules: string[];
  desktopApplications: string[];
  desktopApplicationsTitle: string;
  domainRulesTitle: string;
}

const handleChipMetadata = (string: string) => ({
  label: string,
  key: string,
});

const LinkedServices = (props: ILinkedServicesProps) => {
  const {
    desktopApplicationsTitle,
    domainRulesTitle,
    domainRules = [],
    desktopApplications = [],
  } = props;

  return (
    <Grid container rowSpacing={0.5}>
      {
        !!desktopApplications.length && (
          <>
            <Grid item xs={12}>
              <Typography variant="body1" color={S4}>
                {desktopApplicationsTitle}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ChipsGroup
                background={AB1}
                typographyColor={B1}
                dataset={desktopApplications}
                getMetadata={handleChipMetadata}
              />
            </Grid>
          </>
        )
      }
      {
        !!domainRules.length && (
          <>
            <Grid item xs={12}>
              <Typography variant="body1" color={S4}>
                {domainRulesTitle}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ChipsGroup
                background={AB1}
                typographyColor={B1}
                dataset={domainRules}
                getMetadata={handleChipMetadata}
              />
            </Grid>
          </>
        )
      }
    </Grid>
  );
};

export default memo(LinkedServices);
